import { render } from "./GeneralBoard.vue?vue&type=template&id=1dbd8de0"
import script from "./GeneralBoard.vue?vue&type=script&lang=js"
export * from "./GeneralBoard.vue?vue&type=script&lang=js"

import "./GeneralBoard.vue?vue&type=style&index=0&id=1dbd8de0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__